export default __webpack_public_path__ + "1043468da18e1381a7d757b8cf8c1e3f.svg";